var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("h4", [
        _vm._v("Provisioning Schedule "),
        !_vm.loading && !_vm.schedule
          ? _c("span", { staticClass: "small" }, [_vm._v("(not scheduled)")])
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.schedule
        ? _c("div", [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm-12" }, [
                _c("p", [
                  _vm._v("Provisioning will run daily at: "),
                  _c("b", [_vm._v(_vm._s(_vm.formatScheduleTime()))])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      on: { click: _vm.editSchedule }
                    },
                    [_vm._v("Edit Schedule")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-danger",
                      attrs: { disabled: _vm.deleteLoading },
                      on: { click: _vm.confirmDeleteSchedule }
                    },
                    [_vm._v("Delete Schedule")]
                  )
                ])
              ])
            ])
          ])
        : _c("div", [
            _c(
              "button",
              {
                staticClass: "btn btn-primary",
                on: { click: _vm.setupSchedule }
              },
              [_vm._v("Set up Schedule")]
            )
          ]),
      _vm._v(" "),
      _vm.showScheduleForm
        ? [
            _c("AutoprovisioningScheduleForm", {
              attrs: {
                "domain-uuid": _vm.domainUuid,
                "domain-name": _vm.domainName,
                "existing-schedule":
                  _vm.scheduleFormMode === "edit" ? _vm.schedule : null
              },
              on: {
                scheduleCreated: _vm.handleScheduleCreated,
                scheduleUpdated: _vm.handleScheduleUpdated,
                cancel: function($event) {
                  _vm.showScheduleForm = false
                }
              }
            })
          ]
        : _vm._e(),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            value: _vm.showDeleteScheduleModal,
            title: "Confirm Delete"
          },
          on: {
            hide: function($event) {
              _vm.showDeleteScheduleModal = false
            },
            input: function($event) {
              _vm.showDeleteScheduleModal = $event
            }
          }
        },
        [
          _c("p", [
            _vm._v(
              "Are you sure you want to delete this provisioning schedule?"
            )
          ]),
          _vm._v(" "),
          _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-default",
                attrs: { type: "button", disabled: _vm.deleteLoading },
                on: {
                  click: function($event) {
                    _vm.showDeleteScheduleModal = false
                  }
                }
              },
              [_vm._v("Cancel")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-danger",
                attrs: { type: "button", disabled: _vm.deleteLoading },
                on: { click: _vm.deleteSchedule }
              },
              [
                _vm.deleteLoading
                  ? _c("i", { staticClass: "fa fa-spinner fa-spin" })
                  : _vm._e(),
                _vm._v("\n        Delete\n      ")
              ]
            )
          ])
        ]
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }